// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"88afb37c","238":"a86e230e","450":"5a949980","453":"d88699dd","732":"07d5d7a9"}[chunkId] + ".chunk.js";
};